import { ApolloClient, gql } from '@apollo/client'
import {
  SendDimonaContactsTo4dMutation,
  SendDimonaContactsTo4dMutationVariables
} from './__generated__/SendDimonaContactsTo4dMutation'

const mutation = gql`
  mutation SendDimonaContactsTo4dMutation(
    $input: SendDimonaContactsTo4dInput!
  ) {
    sendDimonaContactsTo4d(input: $input) {
      status
    }
  }
`

export function sendDimonaContactsTo4dMutation(
  apolloClient: ApolloClient,
  options: Omit<
    ApolloClient.MutateOptions<
      SendDimonaContactsTo4dMutation,
      SendDimonaContactsTo4dMutationVariables
    >,
    'mutation'
  >
) {
  return apolloClient.mutate<
    SendDimonaContactsTo4dMutation,
    SendDimonaContactsTo4dMutationVariables
  >({
    mutation,
    ...options
  })
}
